module.exports = __webpack_public_path__ + "img/sainalesser.54b6a160.svg";